// extracted by mini-css-extract-plugin
export var header = "z_q";
export var headerWhite = "z_bz";
export var variant1 = "z_bB";
export var variant2 = "z_bC";
export var variant3 = "z_bD";
export var variant4 = "z_bF";
export var variant5 = "z_bG";
export var variant6 = "z_bH";